module.exports = __webpack_public_path__ + "static/media/adver-pic2.f8502e95.png";